import React from "react";

export default function LoadingScreen() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 24, background: "#050505", position: "relative", overflow: "hidden" }}>
      {/* Orbiting rings */}
      <div style={{ position: "relative", width: 80, height: 80 }}>
        <div style={{ position: "absolute", inset: 0, border: "1px solid #f5c51830", borderRadius: "50%", animation: "rotateRing 2s linear infinite" }} />
        <div style={{ position: "absolute", inset: 8, border: "1px solid #c9a84c50", borderRadius: "50%", animation: "rotateRing 1.4s linear infinite reverse" }} />
        <div style={{ position: "absolute", inset: 20, border: "2px solid #f5c518", borderRadius: "50%", borderTopColor: "transparent", animation: "rotateRing 0.9s linear infinite" }} />
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#f5c518", boxShadow: "0 0 16px #f5c51880, 0 0 32px #f5c51840", animation: "glowOrb 1.5s ease-in-out infinite" }} />
        </div>
      </div>
      <span style={{ fontFamily: "var(--font-mono)", fontSize: "10px", letterSpacing: "0.28em", color: "#333", textTransform: "uppercase", animation: "dotBlink 1.5s ease-in-out infinite" }}>
        Loading
      </span>
    </div>
  );
}

export function PageLoader() {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#050505", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 28, zIndex: 9999 }}>
      <div style={{ position: "relative", width: 100, height: 100 }}>
        <div style={{ position: "absolute", inset: 0, border: "1px solid #f5c51820", borderRadius: "50%", animation: "rotateRing 3s linear infinite" }} />
        <div style={{ position: "absolute", inset: 10, border: "1px solid #c9a84c35", borderRadius: "50%", animation: "rotateRing 2s linear infinite reverse" }} />
        <div style={{ position: "absolute", inset: 24, border: "2px solid #f5c518", borderRadius: "50%", borderTopColor: "transparent", animation: "rotateRing 1s linear infinite" }} />
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#f5c518", boxShadow: "0 0 20px #f5c518, 0 0 40px #f5c51860" }} />
        </div>
      </div>
      <div style={{ fontFamily: "'Barlow',sans-serif", fontWeight: 700, fontSize: "1.2rem", textTransform: "uppercase", letterSpacing: "0.18em", color: "#f0f0f0", animation: "logoGlow 2s ease-in-out infinite" }}>Macro Trader</div>
      <div style={{ fontFamily: "var(--font-mono)", fontSize: "9px", letterSpacing: "0.28em", color: "#333", textTransform: "uppercase" }}>Research & Analysis</div>
    </div>
  );
}
